module.exports = __webpack_public_path__ + "static/media/n26_logo.472e8622.webp";